import { TsRestClient } from '@eluve/api-client-provider';
import { Logger } from '@eluve/logger-main';
import { getMetadataFromFileName } from '@eluve/utils';

import { MarkChunkFinalEvent, TaskHandler } from '../types';

export const markChunkFinalHandler = ({
  client,
  logger,
}: {
  client: TsRestClient | null;
  logger: Logger;
}): TaskHandler<MarkChunkFinalEvent> => {
  return async (task, context) => {
    const { databaseFileId: transcriptId } = getMetadataFromFileName({
      userId: task.userId,
      fileName: task.fileName,
    });

    if (!client) {
      logger.error('API client is not available');
      throw new Error('API client not initialized');
    }

    const response = await client.transcription.markChunkFinal({
      body: {
        appointmentId: task.appointmentId,
        transcriptId,
        isFinalChunk: true,
      },
      params: { tenantId: context.tenantId },
    });

    if (response?.status !== 200) {
      logger.warn('Failed to mark chunk final', {
        fileName: task.fileName,
      });

      throw new Error('Failed to finalize audio record');
    }
  };
};
